import useStore from "./_store"
import HuntUser from "./_HuntUser"
import { useEffect, useImperativeHandle, useMemo, useRef, useState, forwardRef } from "react"


export default forwardRef((_, ref) => {
	const [isLoading, setIsLoading] = useState(false)
	const [userSearch, setUserSearch] = useState('')
	const currentHuntUsers = useStore((state) => state.currentHuntUsers)

	const filteredHuntUsers = useMemo(() => {
		if (currentHuntUsers == null) return null
		if (currentHuntUsers.length === 0) return currentHuntUsers
		const q = userSearch.trim().toLowerCase()
		if (!q) return currentHuntUsers
		return currentHuntUsers.filter((u) => {
			const haystack = [u.first_name, u.last_name, u.user_name, u.email]
				.filter(Boolean)
				.join(' ')
				.toLowerCase()
			return haystack.includes(q)
		})
	}, [currentHuntUsers, userSearch])

	if (!ref) ref = useRef(null)

	useImperativeHandle(ref, () => {
		return {
			setIsLoading,
		}
	})

	useEffect(() => {
		if (currentHuntUsers == null) setUserSearch('')
	}, [currentHuntUsers])

	const loader =
		<div className="grow flex flex-col items-center">
			<div className="lds-ring m-1.5">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>



	let content
	if (currentHuntUsers == null) {
		content = <p>No hunt users found</p>
	} else if (filteredHuntUsers.length === 0 && userSearch.trim()) {
		content = <p>No users match your search</p>
	} else {
		content = filteredHuntUsers.map((huntUser) => (
			<HuntUser key={huntUser.id} user={huntUser} />
		))
	}

	const renderedContent = isLoading ? loader : content

	return <>
		<div className="border-grey rounded-primary p-2 border-normal">
			{currentHuntUsers?.length > 0 && (
				<input
					type="text"
					className="input-field w-full mb-2"
					placeholder="Search users…"
					value={userSearch}
					onChange={(e) => setUserSearch(e.target.value)}
					aria-label="Search users"
				/>
			)}
			<div className="flex flex-col max-h-[400px] overflow-y-auto min-w-[800px] divide-y divide-grey divide-opacity-50">
				{renderedContent}
			</div>
		</div>
	</>
})
